import React, { useState } from "react";
import { Button, Form } from "semantic-ui-react";
import { BasicModal } from "ceco-modal";
import { isEmpty } from "lodash";
import { Alert } from "ceicons";
import { commitMutation } from "react-relay";
import graphql from "babel-plugin-relay/macro";
import environment from "../../../environment";
import { useTranslation } from "ceco-polyglot";
import { ImageDropzone } from "../../ImageDropzone";
import { toast } from "react-toastify";

import "./alertModal.scss";

export default function AlertModal(props) {
  const { trigger, edit = false, alert, refetchData } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [file, setFile] = useState();
  const [fileError, setFileError] = useState();
  const [formErrors, setFormErrors] = useState({});
  const t = useTranslation();

  function handleChange(evt) {
    const { value } = evt.target;
    setFormData({
      ...formData,
      [evt.target.name]: value,
    });
  }

  function editAlert() {
    return new Promise((resolve, reject) => {
      const variables = {
        alert: formData.id,
        slugName: formData?.slugName,
        description: formData?.description,
      };
      let uploadables;
      if (file) {
        uploadables = {
          imageFile: file.file[0],
        };
      }

      commitMutation(environment, {
        mutation: AlertModalUpdateMutation,
        variables,
        uploadables,
        onCompleted(response, errors) {
          if (errors) {
            reject(errors);
          }
          resolve(response);
        },
        onError(error) {
          reject(error);
        },
      });
    });
  }
  function createAlert() {
    return new Promise((resolve, reject) => {
      const variables = {
        slugName: formData?.slugName,
        description: formData?.description,
      };
      let uploadables;
      if (file) {
        uploadables = {
          imageFile: file.file[0],
        };
      }
      commitMutation(environment, {
        mutation: AlertModalCreateMutation,
        variables,
        uploadables,
        onCompleted(response, errors) {
          if (errors) {
            reject(errors);
          }
          resolve(response);
        },
        onError(error) {
          reject(error);
        },
      });
    });
  }

  const onSubmit = async () => {
    if (validateForm()) {
      const action = !edit ? createAlert : editAlert;
      const msg = !edit
        ? t("message.created_alert")
        : t("message.edited_alert");
      action()
        .then((a) => {
          toast.success(msg);
          setModalOpen(false);
          refetchData();
        })
        .catch((e) => {
          if (Array.isArray(e)) {
            toast.error(e[0].message);
          } else {
            toast.error(e.errors[0]?.message);
          }
        });
    }
  };

  const validateForm = () => {
    let errors = {};
    let validate = true;

    if (!formData.slugName) {
      errors = { ...errors, slugName: t("form.errorRequired") };
    }
    if (!formData.description) {
      errors = { ...errors, description: t("form.errorRequired") };
    }
    if (!isEmpty(errors)) {
      validate = false;
    }

    setFormErrors(errors);
    return validate;
  };

  return (
    <BasicModal
      size="mini"
      className="single-button"
      title={
        <div className="modalTitle">
          <Alert />
          {edit ? t("modalTitle.editAlert") : t("modalTitle.createAlert")}
        </div>
      }
      trigger={React.cloneElement(trigger, {
        onClick: (e) => {
          e.preventDefault();
          setModalOpen(true);

          edit ? setFormData({ ...alert }) : setFormData({});
          setFile();
        },
      })}
      actions={
        <Button
          type="submit"
          primary
          onClick={() => {
            onSubmit();
          }}
        >
          {t("button.save")}
        </Button>
      }
      open={modalOpen}
      closeOnEscape={modalOpen}
      closeOnDimmerClick={modalOpen}
      onModalClose={() => setModalOpen(false)}
      showCloseButton={true}
    >
      <Form>
        <ImageDropzone
          circular
          file={file}
          setFile={setFile}
          fileError={fileError}
          setFileError={setFileError}
          imgLoaded={edit && formData.icon}
        />

        <Form.Input
          name="slugName"
          error={formErrors && formErrors["slugName"]}
          value={formData.slugName || ""}
          label={t("form.name")}
          placeholder={t("form.name")}
          onChange={handleChange}
          required
        />

        <Form.TextArea
          name="description"
          error={formErrors && formErrors["description"]}
          value={formData.description || ""}
          label={t("form.description")}
          placeholder={t("form.description")}
          onChange={handleChange}
          required
        />
      </Form>
      <p className="required-modal">{t("form.required")}</p>
    </BasicModal>
  );
}
const AlertModalCreateMutation = graphql`
  mutation AlertModalCreateMutation($slugName: String!, $description: String) {
    warningCreate(input: { slugName: $slugName, description: $description }) {
      warning {
        id
        slugName
        icon
      }
    }
  }
`;
const AlertModalUpdateMutation = graphql`
  mutation AlertModalUpdateMutation(
    $alert: ID!
    $slugName: String!
    $description: String
  ) {
    warningUpdate(
      input: { id: $alert, slugName: $slugName, description: $description }
    ) {
      warning {
        id
        slugName
        description
        icon
      }
    }
  }
`;
